module.exports = __webpack_public_path__ + "img/Carousel-Jobs-and-Careers.f318a508.jpg";